import React from "react";
import i18n from "@/i18n";

import DialogModal from "@/components/dialogModal";
import { cn } from "../utils";

import {
  EXAMPLE_SSN_MASKING_BY_COUNTRY,
  MASKING_LEVELS,
  MaskLevelIcon,
} from "@/components/maskSsnField";

const { t } = i18n;

const DownloadSignedDocumentModal = ({ open, onSubmit, ...dialogProps }) => (
  <DialogModal
    open={open}
    size="sm"
    submitText={null}
    bodyRenderer={() => (
      <div className="flex flex-col gap-8 text-center">
        <p>{t("ssn_masking.choose_level.description")}</p>

        <div className="space-between flex gap-4">
          {MASKING_LEVELS.map((level) => {
            const iconClassName = {
              none: "text-red-500",
              low: "text-amber-500",
              high: "text-lime-600",
              full: "text-emerald-500",
            }[level];

            return (
              <div
                onClick={() => onSubmit(level)}
                className={cn(
                  "flex h-[140px] flex-1 cursor-pointer flex-col items-center justify-between rounded-lg border border-edge px-4 py-8",
                  "hover:border-primary hover:bg-primary/10 hover:text-primary",
                )}
                key={level}
              >
                <div className="font-md flex flex-col items-center gap-2">
                  <MaskLevelIcon
                    className={iconClassName}
                    level={level}
                    size={32}
                  />
                  <span className="font-semibold">
                    {t(`ssn_masking.values.${level}`)}
                  </span>
                </div>
                <div
                  className="font-mono text-[12px]"
                  dangerouslySetInnerHTML={{
                    __html: EXAMPLE_SSN_MASKING_BY_COUNTRY.se[level]
                      .split("")
                      .map((char) =>
                        char === "X"
                          ? "<span style='opacity:0.5'>X</span>"
                          : `<span style='font-weight:bold'>${char}</span>`,
                      )
                      .join(""),
                  }}
                ></div>
              </div>
            );
          })}
        </div>
      </div>
    )}
    {...dialogProps}
  />
);

export default DownloadSignedDocumentModal;
